"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Package, FileText, TrendingUp } from "lucide-react";
export default function SupplierPortalFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const features = [{
    icon: Package,
    title: "Order Management",
    description: "Streamline your order processing with real-time tracking and automated notifications for seamless fulfillment.",
    ctaText: "Learn More",
    ctaLink: "#"
  }, {
    icon: FileText,
    title: "Document Hub",
    description: "Access contracts, invoices, and compliance documents in one secure location with version control.",
    ctaText: "Explore",
    ctaLink: "#"
  }, {
    icon: TrendingUp,
    title: "Performance Analytics",
    description: "Monitor key metrics, delivery performance, and quality scores with comprehensive dashboards.",
    ctaText: "View Metrics",
    ctaLink: "#"
  }];
  return <section id="supplier-portal-features" ref={ref} className="relative w-full overflow-hidden bg-primary py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className={`group relative bg-secondary border-none transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-0.5 hover:shadow-medium ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardHeader>
                  <div className="mb-4 inline-flex size-12 items-center justify-center rounded-sm">
                    <Icon className="size-6 text-accent-dark transition-all duration-[var(--duration-medium)] group-hover:drop-shadow-[0_0_8px_rgba(var(--color-accent),0.6)]" strokeWidth={1} />
                  </div>
                  <CardTitle className="text-xl text-white">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex flex-col gap-6">
                  <p className="text-sm leading-relaxed text-white/80">
                    {feature.description}
                  </p>
                  <Button variant="outline" className="w-fit border-primary bg-transparent text-white transition-all duration-[var(--duration-fast)] hover:bg-white/5" asChild>
                    <Link to={feature.ctaLink}>{feature.ctaText}</Link>
                  </Button>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}